import DOMPurify from 'dompurify';

/**
 * Sanitize user-facing text/HTML to prevent stored/reflected XSS.
 * Strips <script>, event handlers (onerror, onclick, ...), javascript: URLs, etc.
 * Safe to use on testimonials, reviews, and any content that may later come
 * from a CMS, API, or user submission.
 */
export function sanitizeText(input: string): string {
  if (typeof input !== 'string') return '';
  // For plain testimonial copy we allow no tags at all — pure text only.
  return DOMPurify.sanitize(input, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}

/**
 * Sanitize a limited subset of rich HTML (for content that legitimately needs
 * basic formatting). Keeps only safe inline formatting tags.
 */
export function sanitizeRichText(input: string): string {
  if (typeof input !== 'string') return '';
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'br', 'p', 'span'],
    ALLOWED_ATTR: [],
  });
}